"use client";

import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { isAdminFullWidth } from "@/lib/route-layout";

/**
 * 모바일/태블릿(<1024px) 클래식 레이아웃의 본문 래퍼.
 * 데스크탑은 모든 경로가 셸로 렌더되므로(JCG-3679) 데스크탑 전용 xl:max-w 확장 분기는 두지 않는다.
 * 관리자는 태블릿(800~1023px)에서도 표가 잘리지 않도록 폭 제한을 풀어 둔다.
 */
export default function ContentWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  return (
    <div
      className={cn(
        "w-full md:px-4 bg-white dark:bg-background",
        isAdminFullWidth(pathname) ? "max-w-none" : "max-w-[800px]",
      )}
    >
      {children}
    </div>
  );
}
